/** Mirrors backend App\Enums\PlanFeature for form labels when catalog API is unavailable. */
export const PLAN_FEATURE_GROUPS = {
  core: 'Core',
  integrations: 'Integrations',
  team: 'Team & access',
  tools: 'Tools',
  billing: 'Billing',
};

export const PLAN_FEATURE_FALLBACK = [
  { key: 'clients', label: 'Clients', description: 'Create and manage agency clients.', group: 'core' },
  { key: 'projects', label: 'Projects', description: 'Create and manage client projects.', group: 'core' },
  { key: 'portal', label: 'Client portal', description: 'End clients can sign in and view their projects.', group: 'core' },
  {
    key: 'portal_users',
    label: 'Portal user accounts',
    description: 'Create login accounts for client portal users.',
    group: 'core',
  },
  {
    key: 'integrations',
    label: 'Integration settings',
    description: 'Configure API keys and integration settings.',
    group: 'integrations',
  },
  {
    key: 'ghl',
    label: 'Go High Level (GHL)',
    description: 'Sync contacts and opportunities with Go High Level.',
    group: 'integrations',
  },
  {
    key: 'bitwarden',
    label: 'Bitwarden',
    description: 'Sync Bitwarden collections for clients and projects.',
    group: 'integrations',
  },
  {
    key: 'teams',
    label: 'Microsoft Teams / SharePoint',
    description: 'Sync SharePoint / Teams folders for clients and projects.',
    group: 'integrations',
  },
  {
    key: 'team_management',
    label: 'Team & managers',
    description: 'Invite managers to the organization.',
    group: 'team',
  },
  {
    key: 'impersonation',
    label: 'View as user',
    description: 'Preview the portal as another user in the same organization.',
    group: 'team',
  },
  {
    key: 'time_tracker',
    label: 'Time tracker',
    description: 'Track billable time and QuickBooks sync.',
    group: 'tools',
  },
  {
    key: 'priority_support',
    label: 'Priority support',
    description: 'Marked as priority support tier.',
    group: 'billing',
  },
  {
    key: 'client_faq',
    label: 'Client FAQ hub',
    description: 'Build a FAQ hub for each client (text, links, categories).',
    group: 'core',
  },
  {
    key: 'faq_media',
    label: 'FAQ images & files',
    description: 'Attach images and downloadable files to FAQ answers.',
    group: 'core',
  },
  {
    key: 'faq_credentials',
    label: 'FAQ secure credentials',
    description: 'Store logins/passwords with masked reveal for clients.',
    group: 'core',
  },
  {
    key: 'faq_forms',
    label: 'FAQ intake forms',
    description: 'Custom forms for clients to send information to the agency.',
    group: 'core',
  },
  {
    key: 'live_chat',
    label: 'Live chat',
    description: 'Real-time chat with clients and guests via Socket.IO.',
    group: 'core',
  },
  {
    key: 'asset_hub',
    label: 'Media & asset hub',
    description: 'Asset library, upload center, requests, and staff approvals.',
    group: 'core',
  },
  {
    key: 'client_tasks',
    label: 'Client tasks',
    description: 'Assign action items to portal users and track completion.',
    group: 'core',
  },
  {
    key: 'ai_asset_search',
    label: 'AI asset search',
    description: 'Semantic search across the asset library (requires OpenAI).',
    group: 'core',
  },
  {
    key: 'project_integrations',
    label: 'Project integration widgets',
    description: 'Live widgets and tool links on project pages.',
    group: 'integrations',
  },
  {
    key: 'stripe',
    label: 'Stripe',
    description: 'Connect Stripe for client billing pages and webhooks.',
    group: 'integrations',
  },
  {
    key: 'quickbooks',
    label: 'QuickBooks Online',
    description: 'Sync billable time with QuickBooks Online.',
    group: 'integrations',
  },
  {
    key: 'openai',
    label: 'OpenAI',
    description: 'OpenAI API for live chat assistant and AI features.',
    group: 'integrations',
  },
  {
    key: 'figma',
    label: 'Figma',
    description: 'Figma API for file metadata on project pages.',
    group: 'integrations',
  },
  {
    key: 'google_analytics',
    label: 'Google Analytics',
    description: 'GA4 Data API for traffic stats on project pages.',
    group: 'integrations',
  },
  {
    key: 'se_ranking',
    label: 'SE Ranking',
    description: 'SE Ranking API for SEO visibility on project pages.',
    group: 'integrations',
  },
  {
    key: 'hosting',
    label: 'Hosting monitor',
    description: 'HTTP uptime checks for project hosting URLs.',
    group: 'integrations',
  },
  {
    key: 'pm2',
    label: 'PM2 process manager',
    description: 'Manage PM2 processes via the agency PM2 API (list, restart, logs).',
    group: 'integrations',
  },
  {
    key: 'docker',
    label: 'Docker containers',
    description: 'Manage Docker containers via the agency Docker API (list, start/stop, logs).',
    group: 'integrations',
  },
];
